module.exports = __webpack_public_path__ + "static/media/how_hr.5e8cb3bf.vtt";